export default "__VITE_ASSET__DL9fi9Pt__"